module.exports = __webpack_public_path__ + "static/2_1_search-2_DA-463dc8ba9668a803c5003056ac6271c5.svg";